export default ({ data }, { market, t }) => {
  if (!data) {
    return {};
  }

  const { brand } = data;

  if (!brand) {
    return {};
  }
  const meta = {
    name: brand.name,
    productCount: brand.productsTotal,
  };

  const openGraph = [
    { key: 'title', content: brand.name },
    { key: 'type', content: 'company' },
    { key: 'image', content: brand.logo },
  ];

  return {
    canonical: market.domain + brand.pathName,
    thumbnail: brand.logo,
    description: t('meta', 'brand.description', meta),
    title: t('meta', 'brand.title', meta),
    openGraph,
    structuredData: undefined,
    hrefLang: brand.hrefLang,
  };
};
